
import { singularityStore, uiStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class EditContentPropertiesButton extends Vue {
  @Prop()
  elementId!: TreeNode["id"];

  editContentProperties() {
    uiStore.activateElement(this.elementId);
    singularityStore.setContentPropertiesEditorPanelState(true);
    singularityStore.setSingularityLeftPanel("content_properties_editor");
  }
}
